import { render } from "./FunctionalMenus.vue?vue&type=template&id=1663ff47"
import script from "./FunctionalMenus.vue?vue&type=script&lang=js"
export * from "./FunctionalMenus.vue?vue&type=script&lang=js"

import "./FunctionalMenus.vue?vue&type=style&index=0&id=1663ff47&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_a3ee6c512411489faef2ecfce652dcca/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__